import { getApiUrl, getApiAuthenticateUrl } from "./api";
import axios from "axios";
import { formatScadenza } from "../utils/format";
import { convertGG_slash_MM_slash_AAToAAAAMMGG } from "../utils/format";

//NOTA: AXIOS restituisce il payload dentro un oggetto "data"!

export async function getListaVeicoliAttiviUltimiTreAnni(codiceFiscale) {
    const datiRichiesta = {
        "codiceFiscale": codiceFiscale
    }
    let response = await axios.post(getApiUrl() + '/veicoliAttiviUltimiTreAnni', datiRichiesta)
    if (response.data.listaVeicoliAttivi && response.data.listaVeicoliAttivi.length === 0) {
        console.log("Impossibile reperire lista veicoli attivi")
        return undefined;
    }
    console.log('HEADERS', response.headers);
    const sortedList = response.data.listaVeicoliAttivi.sort((a, b) => (convertGG_slash_MM_slash_AAToAAAAMMGG(b.dataInizioProprieta) - convertGG_slash_MM_slash_AAToAAAAMMGG(a.dataInizioProprieta))); //sort alfanumerico crescente;
    return sortedList;
}

export async function getDettagliVeicoloAttivo(idVeicolo) {
    const datiRichiesta = {
        "idVeicolo": idVeicolo
    }
    let response = await axios.post(getApiUrl() + '/veicoloAttivo', datiRichiesta)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

// export async function getPagamentiLiquidazione(annoImposta, idVeicolo) {
//     const datiRichiesta = {
//         "anno": annoImposta,
//         "idVeicolo": idVeicolo
//     }
//     let response = await axios.post(getApiUrl() + '/pagamentiLiquidazione', datiRichiesta)
//      //TODO Gestione errori da fare meglio!
//     if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500) && response.data.pagamenti !== undefined && response.data.pagamenti.length !== 0) {
//         return response.data.pagamenti.sort((a, b) => ('' + a.scadCalcolataMMYYYY).localeCompare(b.scadCalcolataMMYYYY)); //sort alfanumerico crescente
//     }
//     return undefined;
// }

export async function getDettaglioPagamenti(annoImposta, idVeicolo) {
    const datiRichiesta = {
        "anno": annoImposta,
        "idVeicolo": idVeicolo
    }
    let response = await axios.post(getApiUrl() + '/dettaglioPagamenti', datiRichiesta)
    console.log("response", response)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500) && response.data.pagamenti !== undefined && response.data.pagamenti.length !== 0) {
        return response.data.pagamenti.sort((a, b) => ('' + a.dataPagamentoEffettuato).localeCompare(b.dataPagamentoEffettuato)); //sort alfanumerico crescente
    }
    return undefined;
}

// export async function getDettaglioPagamento(annoScadenza, idVeicolo) {
//     const datiRichiesta = {
//         "anno": annoScadenza,
//         "idVeicolo": idVeicolo
//     }
//     let response = await axios.post(getApiUrl() + '/pagamento', datiRichiesta)
//      //TODO Gestione errori da fare meglio!
//     if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500) && response.data.pagamenti !== undefined && response.data.pagamenti.length !== 0) {
//         return response.data.pagamenti.sort((a, b) => ('' + a.dataPagamentoEffettuato).localeCompare(b.dataPagamentoEffettuato)); //sort alfanumerico crescente
//     }
//     return undefined;
// }

export async function getSituazionePagamenti(anno, idVeicolo, idProprietario) {
    const datiRichiesta = {
        "anno": anno,
        "idVeicolo": idVeicolo,
        "idProprietario": idProprietario
    }
    let response = await axios.post(getApiUrl() + '/calcolaSituazione', datiRichiesta)
    console.log("REPONSE DATA", response)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500) && response.data.situazionePagamenti !== undefined && response.data.situazionePagamenti.length !== 0) {
        return response.data.situazionePagamenti.sort((a, b) => parseInt(b.anno) - parseInt(a.anno));  //sort numerico decrescente
    }
    return undefined;
}

export async function getCalcoloTassa(idVeicolo, scadenza, validita) {
    const scadenza_formattata = formatScadenza(scadenza);
    console.log('getCalcoloTassa: idVeicolo', idVeicolo,' scadenza=', scadenza_formattata, ' validita=', validita)
    const datiRichiesta = {
        "idVeicolo": idVeicolo,
        "scadenza": scadenza_formattata,
        "validita": validita
    }
    let response = await axios.post(getApiUrl() + '/calcola', datiRichiesta)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function getTariffaFissa(tipoVeicolo) {
    console.log('getTariffaFissa: tipoVeicolo', tipoVeicolo)
    const datiRichiesta = {
        "tipoVeicolo": tipoVeicolo
    }
    let response = await axios.post(getApiUrl() + '/tariffaFissa', datiRichiesta)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function getCalcoloAutomatico(cf, targa, tipoVeicolo) {
    console.log('getCalcoloAutomatico: cf', cf)
    console.log('getCalcoloAutomatico: targa', targa)
    const datiRichiesta = {
        "codiceFiscale": cf,
        "targa": targa
    }
    if(tipoVeicolo)
        datiRichiesta.tipoVeicolo = tipoVeicolo.value
    let response = await axios.post(getApiUrl() + '/calcoloAutomatico', datiRichiesta)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function getCalcoloAutomaticoExtended(cf, targa, scadenza, validita) {
    console.log('getCalcoloAutomaticoExtended: cf', cf)
    console.log('getCalcoloAutomaticoExtended: targa', targa)
    console.log('getCalcoloAutomaticoExtended: scadenza', scadenza)
    console.log('getCalcoloAutomaticoExtended: validita', validita)
    const datiRichiesta = {
        "codiceFiscale": cf,
        "targa": targa,
        "scadenza": scadenza,
        "validita": validita
    }
    let response = await axios.post(getApiUrl() + '/calcoloTassaNonPagabile', datiRichiesta)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function postPagoTassaPagoPa(datiRichiesta) {
    let response = await axios.post(getApiUrl() + '/pagoTassaPagoPa', datiRichiesta)
    console.log('postPagoTassaPagoPa RES: ', response)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        if(response.data.status === 200){
            return response.data;
        } else {
            return response.data;
        }   
    }
    return undefined;
}

export async function postPagoTassaPagoPaModelloTre(datiRichiesta) {
    let response = await axios.post(getApiUrl() + '/pagoTassaPagoPaModello3', datiRichiesta)
    console.log('postPagoTassaPagoPa RES: ', response)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        if(response.data.status === 200){
            return response.data;
        } else {
            return response.data;
        }   
    }
    return undefined;
}


export async function postRichiestaRimborso(datiRichiesta) {
    let response = await axios.post(getApiUrl() + '/richiestaRimborso', datiRichiesta)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function getTipiVeicoli(){
    let response = await axios.get(getApiUrl() + '/tipiVeicoli')
    console.log('getTipiVeicoli: ', response.data)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function postRichiestaIscrizione(datiRichiestaIscrizione) {
    let response = await axios.post(getApiUrl() + '/iscrizioneAvvisi', datiRichiestaIscrizione)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function postVerificaIscrizione(datiVerificaIscrizione) {
    let response = await axios.post(getApiUrl() + '/verificaIscrizioneAvvisi', datiVerificaIscrizione)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function authenticate() {
    let response = await axios.post(getApiAuthenticateUrl() + '/authenticate')
    console.log('authenticate ',response)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function getAgevolazioni(datiVeicoloProproetario){
    let response = await axios.post(getApiUrl() + '/agevolazioni',datiVeicoloProproetario)
    console.log('authenticate ',response)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}

export async function getRichiesteRimborsoInserite(codiceFiscale){
    const datiRichiesta = {
        "codiceFiscale": codiceFiscale
    }
    let response = await axios.post(getApiUrl() + '/rimborsi',datiRichiesta)
    console.log('authenticate ',response)
    if (response.data !== undefined && (response.data.status !== undefined || response.data.status !== 500)) {
        return response.data;
    }
    return undefined;
}
